module.exports = __webpack_public_path__ + "static/media/dinosaur(6).472bd07c.PNG";